import React, { useState } from "react";
import {
  CancelButton,
  ProceedButton,
  BackArrowButton,
  CloseButton,
} from "../../../elements/button/Button";
import success from "../../../assets/icons/Group.png";
import UploadIcon from "../../../assets/icons/UploadButton.png";
import { uploadPurchaseRegisterFile } from "../../../../Bookclosure/Services/ApiHandler";
import styles from "./UploadFile.module.css";
import commonstyles from "../Forms.module.css";

function UploadFile({
  onProceedToPurchaseUploadedFiles,
  onBack,
  onClose,
  PurchaseID,
}) {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [error, setError] = useState(null);
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();

    const droppedFiles = Array.from(e.dataTransfer.files);

    if (droppedFiles.length > 0) {
      setUploadedFiles((prev) => [...prev, ...droppedFiles]);
      setError("");
    }
  };

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setUploadedFiles((prev) => [...prev, ...newFiles]);
    setError("");
  };

  const handleClose = () => {
    setUploadedFiles([]);
    if (onClose) onClose();
  };

  const handleChange = () => {
    if(onBack) {
      onBack();
    }
  };
  const handleProceed = async () => {
    if (uploadedFiles.length === 0) return;

    try {
      const formData = new FormData();
      uploadedFiles.forEach((file) => formData.append("file", file));

      const res = await uploadPurchaseRegisterFile(PurchaseID, formData);
      console.log("Uploaded:", res.data);

      if (onProceedToPurchaseUploadedFiles)
        onProceedToPurchaseUploadedFiles(uploadedFiles);
        setUploadedFiles([]);
      } catch (err) {
        console.error(err);
        setError("Upload failed.");
    }
  };

  return (
    <div className={commonstyles.backdrop}>
      <div
        className={`${commonstyles.container} ${commonstyles.smallContainer}`}
      >
        <div className={commonstyles.header}>
          <div className={commonstyles.headerLeft}>
            <BackArrowButton onClick={onBack} />
            <h2 className={commonstyles.heading}>
              Upload Purchase Register(Multiple Excel Files)
            </h2>
          </div>
          <CloseButton onClick={handleClose} />
        </div>

        <div className={styles.center}>
          <div className={styles.rightUploadTxt}>
            <h6 className={styles.textUpload}>Upload as sheets</h6>
            <span className={styles.changetxt} onClick={handleChange}>Change</span>
          </div>
          <div className={styles.uploadBox}
            onDragOver={handleDragOver}
            onDrop={handleDrop}>
            <p className={styles.dragText}>Drag and drop your file here or</p>
            <label htmlFor="fileInput" className={styles.uploadBtn}>
              <span className={styles.uploadImgText}>
                <img
                  src={UploadIcon}
                  className={styles.uploadImg}
                  alt="Upload"
                />
                <h6 className={styles.uploadText}>Upload</h6>
              </span>
            </label>
            <input
              id="fileInput"
              className={styles.hiddenInput}
              type="file"
              multiple
              accept=".csv,.xlsx,.xls"
              onChange={handleFileChange}
            />
          </div>

          {uploadedFiles.length > 0 ? (
                  <p className={styles.fileName}>
                    <img src={success} alt="success" className={styles.successTick} />
                    {uploadedFiles.length} {uploadedFiles.length === 1 ? "file" : "files"} uploaded
                  </p>
                ) : (
                  <p className={styles.note}>
                    File you upload must contain all the mandatory fields for mapping.
                  </p>
                )}

          {error && <p className={styles.errorText}>{error}</p>}
        </div>

        <div className={commonstyles.footer}>
          <CancelButton onClick={handleClose} />
          <ProceedButton
            disabled={uploadedFiles.length === 0}
            onClick={handleProceed}
          />
        </div>
      </div>
    </div>
  );
}

export default UploadFile;
